import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'
import EmailVerificationButtonLabel from './EmailVerificationButtonLabel'
import EmailVerificationEmailRow from './EmailVerificationEmailRow'

const EmailVerificationPrimaryOffer = (props) => {
  const {
    email, onSendCode, onDifferentEmail, onRemindLater, sendCodeLoading,
    errorMessage,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration />
      <div className='emailVerificationFlow-title'>Please verify your email address</div>
      <div className='emailVerificationFlow-description'>
        We&apos;ll send you an email to confirm you control the email address.
      </div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Email address</div>
        <EmailVerificationEmailRow
          email={email}
          onEdit={onDifferentEmail}
          editAriaLabel='Update email address'
        />
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      <button
        type='button'
        className='btn btn--blue btn--large'
        onClick={onSendCode}
        disabled={sendCodeLoading}
      >
        <EmailVerificationButtonLabel label='Verify' loading={sendCodeLoading} />
      </button>
      <div className='emailVerificationFlow-primaryOffer-links'>
        <button
          type='button'
          className='emailVerificationFlow-linkBtn'
          onClick={onRemindLater}
        >
          Remind me later
        </button>
      </div>
    </div>
  )
}

export default EmailVerificationPrimaryOffer
